import { useGenerateSummary } from '@/api/hooks/useGenerateSummary';
import { useUpdateLesson } from '@/api/hooks/useLesson';
import { useToast } from '@/hooks/useToast';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export const useSummary = () => {
  const params = useParams();
  const { showToast } = useToast();
  const [content, setContent] = useState<string>('');
  const [showSaveButton, setShowSaveButton] = useState(true);
  const { mutate: generateSummary, isPending } = useGenerateSummary();
  const { mutate: updateLesson } = useUpdateLesson();

  const handleContentChange = (newContent: string) => {
    setContent(newContent);
    setShowSaveButton(true);
  };

  const handleGenerateSummary = () => {
    generateSummary(
      { lessonId: params?.lessonId },
      {
        onSuccess: (data) => {
          if (data.content) {
            setContent(data.content.summary);
            setShowSaveButton(true);
          }
        },
      },
    );
  };

  const handleSaveSummary = () => {
    if (!params?.lessonId) return;

    updateLesson(
      {
        id: params.lessonId,
        input: {
          summary: {
            text: content,
            html: content,
          },
        },
      },
      {
        onSuccess: () => {
          showToast('Le résumé a été enregistré avec succès', 'success', {
            autoClose: 3000,
            position: 'top-right',
          });
          setContent('');
          setShowSaveButton(false);
        },
      },
    );
  };

  return {
    isPending,
    content,
    showSaveButton,
    handleContentChange,
    handleGenerateSummary,
    handleSaveSummary,
  };
};
